import { Page404, routes } from '@/pages'
import { Trans } from '@lingui/react/macro'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { HomeRedirect } from './HomeRedirect'
import { PrivateRoute } from './PrivateRoute'
import {
  RouteLayout,
  RouteLayoutProlific,
  RouteLayoutWebview,
  RouteLayoutWithLeftSideMenu,
} from './RouteLayouts'

const publicRoutes = Object.values(routes).filter((route) => route.isPublic || route.noMenu)
const webviewRoutes = Object.values(routes).filter((route) => route.isWebview)
const prolificRoutes = Object.values(routes).filter((route) => route.isProlific)
const privateRoutes = Object.values(routes).filter(
  (route) => !route.isPublic && !route.noMenu && !route.isWebview && !route.isProlific,
)

export const Layout = () => (
  <>
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <RouteLayoutWebview />
          </PrivateRoute>
        }
      >
        {webviewRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense
                fallback={
                  <div>
                    <Trans>Loading...</Trans>
                  </div>
                }
              >
                <Component />
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route
        element={
          <PrivateRoute>
            <RouteLayoutWithLeftSideMenu />
          </PrivateRoute>
        }
      >
        {privateRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense
                fallback={
                  <div>
                    <Trans>Loading...</Trans>
                  </div>
                }
              >
                <Component />
              </Suspense>
            }
          />
        ))}
        <Route path="/" element={<HomeRedirect />} />
      </Route>
      <Route element={<RouteLayoutProlific />}>
        {prolificRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense
                fallback={
                  <div>
                    <Trans>Loading...</Trans>
                  </div>
                }
              >
                <Component />
              </Suspense>
            }
          />
        ))}
      </Route>
      <Route element={<RouteLayout />}>
        {publicRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense
                fallback={
                  <div>
                    <Trans>Loading...</Trans>
                  </div>
                }
              >
                <Component />
              </Suspense>
            }
          />
        ))}
        <Route path="*" element={<Page404 />} />
      </Route>
    </Routes>
  </>
)
